import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'decimals',
  standalone: true
})
export class DecimalsPipe implements PipeTransform {
  transform(value: number, decimals: number = 0): string {
    if (value == null || isNaN(value)) return '';
    return value.toFixed(decimals);
  }
}
